import { modelsSystemsState } from '@completeanatomy/models-panel';

export function getModelIndex(
  modelId?: string,
  bodyRegion?: string | null,
  systemId?: string | null
): number {
  let index = -1;

  if (bodyRegion) {
    index = modelsSystemsState.findIndex(
      m => m.identifier === modelId && m.mask === JSON.parse(bodyRegion)
    );
  } else if (systemId) {
    index = modelsSystemsState.findIndex(
      m => m.identifier === systemId && m.type === -1
    );
  } else if (modelId) {
    index = modelsSystemsState.findIndex(m => m.identifier === modelId);
  }

  return index;
}
